import React, { useState } from "react";
import { Link } from "react-router-dom";
import blood from "../../assets/images/blood.png";
import tb from "../../assets/images/tb.png";
import sent from "../../assets/images/sent.png";
import d1 from "../../assets/images/dark/d1.png";
import d2 from "../../assets/images/dark/d2.png";
import d3 from "../../assets/images/dark/d3.png";
import Doodle from "../../assets/images/Doodles.png";
import styled from "styled-components";
import { Stack, Progress } from "@chakra-ui/react";
import {
  Activities_Search,
  Clinic,
  useFindRecentActivitiesQuery,
} from "../../generated/graphql";
import formatDate from "../../utils/formatDate";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import Empty from "../Empty";
import FilterRecentActivities from "../FIlter/NewFilter";

const Section = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Loading = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - 400px);
  justify-content: center;
`;

const NoTask = () => {
  return (
    <Section className="mt-10">
      <img src={Doodle} alt=""/>
      <p className="mt-2 text-center">
        You have no recent activity. <br />
        Don't worry, all it takes is one click
      </p>
      <Link
        to={"/app/earn"}
        className="bg-[#4285F4] mt-4 text-base text-white font-bold px-6 py-2.5 rounded-full cursor-pointer"
      >
        Earn
      </Link>
    </Section>
  );
};

export default function RecentActivities() {
  const loggedInRole = useSelector(
    (state: RootState) => state.loggedInUser.role
  );
  const loggedInClinic: Clinic = useSelector(
    (state: RootState) => state.loggedInUser.clinic
  );

  const [filter, setFilter] = useState(Activities_Search.All);

  const {
    data: recentData,
    loading: recentLoading,
    error: recentError,
    refetch: recentRefetch,
  } = useFindRecentActivitiesQuery({
    fetchPolicy: "cache-and-network",
    variables: {
      input: {
        clinicId: loggedInClinic?.id ?? null,
        role: loggedInRole,
        search: filter,
      },
    },
  });

  async function handleFilter(value: Activities_Search) {
    recentRefetch({
      input: {
        clinicId: loggedInClinic?.id ?? null,
        role: loggedInRole,
        search: value,
      },
    });
    setFilter(value);
  }

  if (recentError) <Empty text={recentError.message} />;

  if (recentLoading) {
    return (
      <div>
        <Loading>
          <Stack>
            <Progress size="xs" isIndeterminate />
          </Stack>
        </Loading>
      </div>
    );
  }

  return (
    <div className="relative px-4">
      <div>
        <div
          className={`mb-2 flex justify-between items-center`}
          style={{ maxWidth: "inherit", width: "inherit" }}
        >
          <span className="activity">RECENT ACTIVITIES </span>
          <div className="z-30">
            <FilterRecentActivities
              handleFilter={handleFilter}
              filter={filter}
            />
          </div>
        </div>
      </div>
      {recentData?.findRecentActivities?.data &&
      recentData?.findRecentActivities?.data.length > 0 ? (
        <div className="relative max-w-[500px] w-full">
          {recentData.findRecentActivities.data.map((activity, i) => {
            let ui = Math.floor(Math.random() * 3);
            return (
              <div key={i}>
                {activity.type === "TASK_INTERACTION" ||
                activity.type === "INTERACTION" ||
                "HOME_VISIT" ? (
                  <>
                    {ui === 0 ? (
                      <div
                        key={i}
                        className="py-2 relative blood mb-2 px-3 bg-[#FFFBE5] dark:bg-transparent shadow-sm grid grid-cols-[1fr,auto] items-center"
                      >
                        <div className="absolute top-0 w-full h-full">
                          <img
                            src={blood}
                            alt=""
                            className="w-full h-full dark:hidden"
                          />
                          <img
                            src={d1}
                            alt=""
                            className="w-full h-full hidden dark:block"
                          />
                        </div>
                        <div className="z-10">
                          <p className="dark:text-[#FFD100] text-base mb-1">
                            {activity?.name}
                          </p>
                          <p className="text-sm text-gray-300">
                            {formatDate(activity?.createdAt)}
                          </p>
                        </div>
                        {activity.reward && (
                          <p className="z-10 font-semibold">
                            A {activity.reward.toFixed(2)}
                          </p>
                        )}
                      </div>
                    ) : ui === 1 ? (
                      <div
                        key={i}
                        className="py-2 mb-2 relative px-3 bg-[#FFEBEB] dark:bg-transparent shadow-sm grid grid-cols-[1fr,auto] items-center"
                      >
                        <div className="absolute top-0 w-full h-full">
                          <img
                            src={tb}
                            alt=""
                            className="w-full h-full dark:hidden"
                          />
                          <img
                            src={d2}
                            alt=""
                            className="w-full h-full hidden dark:block"
                          />
                        </div>
                        <div className="z-10">
                          <p className="dark:text-[#F9423A] text-base mb-1">
                            {activity?.name}
                          </p>
                          <p className="text-sm text-gray-300">
                            {formatDate(activity?.createdAt)}
                          </p>
                        </div>
                        <p className="z-10 font-semibold">
                          A {activity?.reward.toFixed(2)}
                        </p>
                      </div>
                    ) : (
                      <div
                        key={i}
                        className="py-2 mb-2 relative px-3 bg-[#E9FAF2] dark:bg-transparent shadow-sm grid grid-cols-[1fr,auto] items-center"
                      >
                        <div className="absolute top-0 w-full h-full">
                          <img
                            src={sent}
                            alt=""
                            className="w-full h-full dark:hidden"
                          />
                          <img
                            src={d3}
                            alt=""
                            className="w-full h-full hidden dark:block"
                          />
                        </div>
                        <div className="z-10">
                          <p className="dark:text-[#F9423A] text-base mb-1">
                            {activity?.name}
                          </p>
                          <p className="text-sm text-gray-300">
                            {`${formatDate(activity?.createdAt)}`}
                          </p>
                        </div>
                        <p className="z-10 font-semibold">
                          A {activity?.reward.toFixed(2)}
                        </p>
                      </div>
                    )}
                  </>
                ) : null}
              </div>
            );
          })}
        </div>
      ) : (
        <div>
          <NoTask />
        </div>
      )}
    </div>
  );
}
